import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/readmore.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {mobileNav} from "./modules/mobileNav";
import {fullHeightPage} from "./modules/fullHeightPage";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {caseStudySlider} from "./modules/caseStudySlider";
import {insertSvgPagination} from "./modules/insertSvgPagination";
import {customSelect} from "./modules/customSelect";
import {popupOpener} from "./modules/popupOpener";
import {animationOnScroll} from "./modules/animationOnScroll";
import {video} from "./modules/video";
import {smallCaseStudySlider} from "./modules/smallCaseStudySlider";
import {communitiesSlider} from "./modules/communitiesSlider";
import {stickyElement} from "./modules/stickyElement";
import {anchorsCompanies} from "./modules/anchorsCompanies";
import {testimonialsTeammatesSlider} from "./modules/testimonialsTeammatesSlider";
import {heroSectionSlider} from "./modules/heroSectionSlider";
import {communitiesMap} from "./modules/communitiesMap";
import {infoSlider} from "./modules/infoSlider";
import {newsFilter} from "./modules/newsFilter";
import {articleGallery} from "./modules/articleGallery";
import {locationsMap} from "./modules/locationsMap";
import {historyAnchors} from "./modules/historyAnchors";
import {companyPortfolio} from "./modules/companyPortfolio";
import {careersSlider} from "./modules/careersSlider";
import {tabs} from "./modules/tabs";
import {youtubeBg} from "./modules/youtubeBg";
import {readmoreInit} from "./modules/readmoreCustom";


binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": mobileNav,
        ".testimonials-slider .slider": testimonialsSlider,
        ".case-study-slider": caseStudySlider,
        ".pagination": insertSvgPagination,
        "select": customSelect,
        ".popup-opener, #big-map": popupOpener,
        ".has-animation": animationOnScroll,
        ".video-holder": video,
        ".read-more-container": readmoreInit,
        ".sticky-element-wrap": stickyElement,
        ".companies-holder": anchorsCompanies,
        ".small-case-study-slider": smallCaseStudySlider,
        ".communities-slider": communitiesSlider,
        ".testimonials-teammates .slider": testimonialsTeammatesSlider,
        ".hero-section-slider": heroSectionSlider,
        ".communities-locations #map": communitiesMap,
        ".info-slider .slider": infoSlider,
        ".news-filters": newsFilter,
        ".article-gallery": articleGallery,
        ".info-cascade .map-holder": locationsMap,
        ".years-nav": historyAnchors,
        ".holder-company-portfolio": companyPortfolio,
        ".careers-slider": careersSlider,
        ".tab-nav li": tabs,
        "#youtube-bg": youtubeBg
    },
    runTests: false
});
window.initCustomSelect = function () {
    customSelect();
};
window.initPagination = function () {
    insertSvgPagination();
};


// WEBPACK FOOTER //
// ./assets/js/global.js